import {useIsSakuraSelected} from '../../../hooks/useIsSakuraSelected'
import {useBooleanUserProperty} from '../../../hooks/useUserProperty'
import {isSakuraRelaseBunnerEnabled} from '../../../utils/featureToggles'
import {isEmbedded} from '../../../utils/isEmbedded'
import {UserProperties} from '../../../utils/userProperties'

export const useSakuraReleaseBanner = () => {
  const sakuraSelected = useIsSakuraSelected()
  const isEnabledForUser = useBooleanUserProperty(UserProperties.SHOW_SAKURA_RELEASE_BANNER, true)

  if (!isEnabledForUser || !isSakuraRelaseBunnerEnabled) {
    return false
  }

  return !isEmbedded && !sakuraSelected
}
